<script>
import AdminLayout from '@layouts/admin-main'
import PrivateApplicationList from '@components/admin/private-application-list'

export default {
  page: {
    title: 'Admin::PrivateApplicationList',
    meta: [{ name: 'description', content: 'Admin::PrivateApplicationList' }],
  },
  components: { AdminLayout, PrivateApplicationList },
}
</script>

<template>
  <AdminLayout>
    <PrivateApplicationList></PrivateApplicationList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
